import { FC } from 'react';
import { useBundle } from '@amzn/react-arb-tools';
import Header from '@amzn/awsui-components-core/header';
import ContentLayout from '@amzn/awsui-components-core/content-layout';
import CampaignCardGrid, {
  CampaignTypeConfig,
} from 'src/components/organisms/CampaignCardGrid';
import { ROUTES } from 'src/routes/valueMatching/routes';
import { HOMEPAGE_MESSAGE_BUNDLE } from 'src/constants';
import { t } from 'src/utils/helpers';

const CAMPAIGN_TYPES: CampaignTypeConfig[] = [
  {
    titleKey: 'ncemi_title',
    descriptionKey: 'ncemi_description',
    createRoute: ROUTES.NO_COST_EMI_CREATE,
    viewRoute: ROUTES.NO_COST_EMI_LIST,
  },
  {
    titleKey: 'prepaid_discount_title',
    descriptionKey: 'prepaid_discount_description',
    createRoute: ROUTES.PREPAID_TRANSACTION_DISCOUNT_CREATE,
    viewRoute: ROUTES.PREPAID_TRANSACTION_DISCOUNT_LIST,
  },
  {
    titleKey: 'buyback_title',
    descriptionKey: 'buyback_description',
    createRoute: ROUTES.BUYBACK_CREATE,
    viewRoute: ROUTES.BUYBACK_LIST,
  },
  {
    titleKey: 'deal_title',
    descriptionKey: 'deal_description',
    createRoute: ROUTES.DEAL_CREATE,
    viewRoute: ROUTES.DEAL_LIST,
  },
];

const HomePage: FC = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE);

  return (
    <ContentLayout
      header={
        <Header
          variant="h1"
          description={t(bundle, 'homepage_description')}
        >
          {t(bundle, 'homepage_title')}
        </Header>
      }
    >
      <CampaignCardGrid
        bundle={bundle}
        campaignTypes={CAMPAIGN_TYPES}
        headerKey="campaign_types_header"
      />
    </ContentLayout>
  );
};

export default HomePage;
